// Single QueryClient instance for the whole app.
//
// It lives here (rather than in index.js) so non-React modules — the axios
// auth-failure hook, the logout/identity reset helpers — can clear cached
// candidate PII without importing the React entrypoint.
import { QueryClient, QueryCache } from 'react-query';
import toast from 'react-hot-toast';
import { formatApiError } from './errors';

const queryCache = new QueryCache({
  onError: (error, query) => {
    // Opt out with `useQuery(key, fn, { meta: { silentError: true } })`.
    if (query?.meta?.silentError) return;
    // 401 is handled by the auth-failure hook in utils/api.js, which signs the
    // tab out — a toast on top of that is noise.
    if (error?.response?.status === 401) return;
    // A single toast id collapses the burst you get when a dashboard loads six
    // queries and the connection is down.
    toast.error(formatApiError(error, 'Could not load this data.'), { id: 'query-error' });
  },
});

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
      staleTime: 30000,
    },
  },
});

export default queryClient;
